import { useAtomValue } from 'jotai'
import { debugModeAtom } from 'sierra-client/state/settings'

export function useIsDebugMode(): boolean {
  return useAtomValue(debugModeAtom)
}
